<template>
  <div class="assistent-card">
    <div class="assistent-card-main">
      <div class="assistent-card-header">
        <img
          v-if="assistent.avatar"
          class="woot-thumbnail"
          :src="assistent.avatar"
          alt="Avatar do Assistente"
        />
        <img
          v-else
          class="woot-thumbnail"
          src="~dashboard/assets/images/chatwoot_bot.png"
          alt="Avatar Padrão"
        />
        <h4 class="assistent--name">{{ assistent.name }}</h4>
      </div>
      <p class="assistent-card-description">{{ assistent.description }}</p>
      <div class="assistent-card-status">
        <span class="assistent-card-status-item">
          <fluent-icon
            v-tooltip.top="
              $t('INTEGRATION_SETTINGS.ASSISTENT.TOOLTIP_KNOWLEDGE_BASE')
            "
            icon="knowledge-base"
            size="22"
            class="assistent-card-status-icon"
            viewBox="0 0 20 26"
          />
          {{ hasKnowledgeBase ? 'SIM' : 'NÃO' }}
        </span>
        <span class="assistent-card-status-item">
          <fluent-icon
            v-tooltip.top="
              $t('INTEGRATION_SETTINGS.ASSISTENT.TOOLTIP_INTERNET_ACCESS')
            "
            icon="internet-access"
            size="22"
            class="assistent-card-status-icon"
            viewBox="0 0 24 26"
          />
          {{ hasInternetAccess ? 'SIM' : 'NÃO' }}
        </span>
      </div>
    </div>

    <div class="assistent-card-actions">
      <woot-button
        v-tooltip.top="$t('INTEGRATION_SETTINGS.ASSISTENT.DELETE.BUTTON_TEXT')"
        variant="smooth"
        color-scheme="alert"
        size="tiny"
        icon="dismiss-circle"
        @click="$emit('delete', assistent, index)"
      />
      <router-link
        class="button small"
        :to="{
          name: 'virtual_assistant_show',
          params: { assistentId: assistent.id },
        }"
      >
        {{ $t('INTEGRATION_SETTINGS.ASSISTENT.CONFIGURE.BUTTON_TEXT') }}
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    assistent: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasKnowledgeBase() {
      return !!this.assistent.vector_store_id;
    },
    hasInternetAccess() {
      return this.assistent.domains.length > 0;
    },
  },
};
</script>
<style scoped lang="scss">
.assistent-card {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--color-border-light);
  border-radius: var(--border-radius-medium);
  box-shadow: 0 0.6rem 1.6rem rgba(16, 24, 40, 0.04);
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-small);
  padding: var(--space-normal);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.assistent-card-main {
  flex: 1;
  min-width: 0;
}

.assistent-card-header {
  align-items: center;
  display: flex;
  gap: var(--space-small);
}

.assistent--name {
  color: var(--s-900);
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-bold);
  margin: 0;
  word-break: break-word;
}

.assistent-card-description {
  color: var(--s-700);
  line-height: 1.6;
  margin: var(--space-micro) 0 var(--space-small);
}

.assistent-card-status {
  align-items: center;
  display: flex;
  gap: var(--space-normal);
}

.assistent-card-status-item {
  align-items: center;
  display: flex;
  font-size: var(--font-size-mini);
  gap: var(--space-micro);
}

.assistent-card-status-icon {
  color: var(--b-600);
  fill-rule: evenodd;
}

.assistent-card-actions {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: var(--space-normal);
  margin-left: var(--space-normal);
}

.woot-thumbnail {
  border-radius: 50%;
  height: 5rem;
  width: 5rem;
}

@media screen and (max-width: 768px) {
  .assistent-card {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--space-small);
  }

  .assistent-card-actions {
    justify-content: flex-start;
    margin-left: 0;
    width: 100%;
  }
}
</style>
